import { render, staticRenderFns } from "./HomeV2.vue?vue&type=template&id=7005cc2d"
import script from "./HomeV2.vue?vue&type=script&lang=js"
export * from "./HomeV2.vue?vue&type=script&lang=js"
import style0 from "./HomeV2.vue?vue&type=style&index=0&id=7005cc2d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports